import type { Doctor } from '@/types/doctor-v2';

export const ultrasoundclinic: Doctor = {
  title: 'Ultrasound Clinic',
  slug: 'ultrasound-clinic',
  fullName: 'Ultrasound Clinic',
  email: ['radiology.admin@lips.org.uk'],
  assistantPhoneNumber: '+44 (207 164 6114',
  assistantEmailAddresses: ['radiology.admin@lips.org.uk'],
  heading: 'Ultrasound Clinic',
  description: 'Ultrasound Clinic',
  primaryPrice: '100',
  secondaryPrice: '100',
  serviceAccount: true,
  bookable: true,
  primarySpeciality: undefined,
  specialities: ['Ultrasound'],
  gender: 'Female',
  languages: ['English'],
  primaryLocations: [
    {
      heading: 'LIPS Healthcare, Battersea Power Station',
      description:
        'Battersea Power Station, Turbine Hall B, Level 1, London, SW11 8DD\n+440207 164 6114\nhttps://lips.org.uk/',
    },
  ],
  privateLocations: [
    {
      heading: 'LIPS Healthcare, Battersea Power Station',
      description:
        'Battersea Power Station, Turbine Hall B, Level 1, London, SW11 8DD\n+440207 164 6114\nhttps://lips.org.uk/',
    },
  ],
  buttons: [
    {
      title: 'Book an appointment',
      slug: 'book-an-appointment/step1/',
      buttonType: 'Default',
      functionality: '',
    },
    {
      title: 'Send Us a Message',
      slug: 'contact-us',
      buttonType: 'Outlined',
      functionality: '',
    },
  ],
  tabSection: [
    {
      heading: 'Biography',
      description: "LIPS Healthcare's Ultrasound Clinic",
    },
  ],
  apiId: '302',
  categoryName: 'Radiology',
  categoryId: '91',
  duration: null,
  metaTitle: 'Ultrasound Clinic  | LIPS Battersea',
  metaDescription: 'Ultrasound Clinic at LIPS Healthcare, London.',
  metaKeywords: [],
  canonicalTag: 'https://lips.org.uk/our-specialists/ultrasound-clinic/',
};
